<template>
    <div class="box">
      <Breadcrumb class="navigation">
        <BreadcrumbItem v-for="item in breadMenuData"
          :to="item.path">
          {{ item.name }}
        </BreadcrumbItem>
      </Breadcrumb>
      <div class="contact-box">
          <p class="tit">{{ $t('key1006711') }}</p>
          <p>{{ $t('key1006712') }}</p>
          <p>{{ $t('key1006713') }}</p>
      </div>
    </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';

export default {
  name: 'contactUs',
  mixins: [Mixin],
  data () {
    return {
      breadMenuData: [{
        path: '/index',
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562')
      },{
        path: '/contactUs',
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000081')
      }]
    };
  },
  created () {

  },
  props: {},
  watch: {},
  methods: {}
};
</script>

<style scoped lang="less">
.box {
  width: 1200px;
  margin: 0 auto;

  .navigation {
    padding: 10px;
  }
  .contact-box {
    background-color: #ffffff;
    margin-bottom: 20px;
    padding: 24px 32px 24px 32px;
    line-height: 32px;
    min-height: 500px;
    color: #000;
    .tit {
      font-weight: bold;
    }
  }
}
</style>
